import * as React from "react";
import { toast } from "react-toastify";
import { defaultToastOptions } from "../index.js";
import PlainEditor from "../../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import TextInput from "../../../../../../../merchant/panel/scripts/shared/input/textinput.js";
import executeRequest from "../../../../../modules/request.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import "./oneTImeOfferOrderingContainer.css";
export function OneTimeOfferOrderingContainer(props) {
    var _a, _b;
    const { offer } = props;
    const [input, setInput] = React.useState("");
    async function patchOffer() {
        const response = await executeRequest("/api/public/users/gallery/oneTimeOffer", "PATCH", {
            offerName: offer.name,
            textInput: input,
            added: true,
            categoryIndex: props.categoryIndex,
        });
        if (response.status != 200) {
            toast.error("Nie udało się dodać do koszyka", defaultToastOptions);
            return;
        }
        toast.success("Dodano do koszyka", defaultToastOptions);
        props.onExit();
    }
    return (React.createElement("div", { className: "one-time-offer-ordering-container" },
        React.createElement(PlainEditor, { example: offer.extra.description, label: "", onChange: () => { }, editable: false }),
        typeof offer.price === "number" && React.createElement(React.Fragment, null,
            "Cena: ",
            offer.price,
            " z\u0142"),
        ((_a = offer.textInput) === null || _a === void 0 ? void 0 : _a.enabled) && (React.createElement(TextInput, { label: "", placeholder: (_b = offer.textInput) === null || _b === void 0 ? void 0 : _b.placeholder, value: input, onChange: setInput })),
        React.createElement("div", { className: "one-time-offer-ordering-container-buttons" },
            React.createElement(Button, { text: "Pomi\u0144", value: "go_back", version: "alternative", onClick: props.onExit }),
            React.createElement(Button, { text: "Dodaj do koszyka", value: "add_to_bucket", onClick: () => {
                    patchOffer();
                } }))));
}
